import React, { useState, useEffect } from 'react';

import {
  Button,
  FormControlLabel,
  Grid,
  Switch,
  TextareaAutosize,
  TextField,
} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

import {
  makeStyles,
  createStyles,
  Theme as AugmentedTheme,
} from '@material-ui/core/styles';
import { Editor } from '@tinymce/tinymce-react';
import { config } from 'config';

const useStyles = makeStyles((theme: AugmentedTheme) =>
  createStyles({
    submit: {
      margin: theme.spacing(3, 0, 2),
      display: 'inline',
    },
    sectionOutline: {
      width: '100%',
      border: '1px solid #aaffaa',
      background: '#efefef',
      padding: '10px 20px',
      margin: '0 auto',
      marginTop: '10px',
    },
    radioOptions: {
      marginTop: '0px',
      flexDirection: 'row',
    },
  }),
);

export default function MessageForm({ message, updateMessage }) {
  const [value, setValue] = useState(message.html.message ?? '');
  const [waState, setWaState] = useState(message.whatsApp.state ?? false);
  const [smsState, setSmsState] = useState(message.sms.state ?? false);
  useEffect(() => setValue(message.html.message ?? ''), [message.html.message]);

  const classes = useStyles();

  return (
    <section>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography variant="h6">{message.title}</Typography>
          <Typography variant="body1">{message.description}</Typography>

          <Typography variant="body1">Correo electrónico</Typography>

          <TextField
            name="subject"
            label="Asunto"
            defaultValue={message.html.subject}
            disabled={!message.enabled}
            onChange={e => {
              message.html.subject = e.target.value;
            }}
            variant="outlined"
            margin="normal"
            required
            fullWidth
          />

          <TextField
            name="greetings"
            label="Saludo"
            defaultValue={message.html.greetings}
            disabled={!message.enabled}
            onChange={e => {
              message.html.greetings = e.target.value;
            }}
            variant="outlined"
            margin="normal"
            fullWidth
          />

          <Editor
            apiKey={config.UI.tinyAPIKey}
            initialValue={message.html.message}
            disabled={!message.enabled}
            value={value}
            onEditorChange={(newValue, editor) => {
              setValue(newValue);
            }}
            init={{
              height: 300,
              menubar: false,
              relative_urls: false,
              convert_urls: false,
              plugins: [
                'advlist autolink lists link image charmap print preview anchor',
                'searchreplace visualblocks code fullscreen',
                'insertdatetime media table paste code help wordcount',
              ],
              toolbar:
                'undo redo | formatselect | ' +
                'bold italic superscript subscript backcolor | alignleft aligncenter ' +
                'alignright alignjustify | bullist numlist outdent indent | ' +
                'removeformat | link image | code | help',
              content_style:
                'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
            }}
          />

          <TextField
            name="actionTitle"
            label="Título Botón de Acción"
            defaultValue={message.html.actionTitle}
            disabled={!message.enabled}
            onChange={e => {
              message.html.actionTitle = e.target.value;
            }}
            variant="outlined"
            margin="normal"
            fullWidth
          />

          <TextField
            name="actionUrl"
            label="URL del botón"
            defaultValue={message.html.actionUrl}
            disabled={!message.enabled}
            onChange={e => {
              message.html.actionUrl = e.target.value;
            }}
            variant="outlined"
            margin="normal"
            fullWidth
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="body1">
            WhatsApp
            <FormControlLabel
              control={
                <Switch
                  checked={waState}
                  disabled={!message.enabled}
                  onChange={data => {
                    message.whatsApp.enabled = data.target.checked;
                    setWaState(message.whatsApp.enabled);
                  }}
                  inputProps={{ 'aria-label': 'WhastApp Habilitado' }}
                />
              }
              label="Habilitado"
              style={{ marginLeft: 20 }}
            />
          </Typography>

          <TextareaAutosize
            name="whatsApp"
            minRows={5}
            placeholder="Escriba el mensaje para WhatsApp"
            defaultValue={message.whatsApp.message}
            disabled={!message.enabled || !waState}
            onChange={e => {
              message.whatsApp = e.target.value;
            }}
            required
            style={{ width: '100%' }}
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="body1">
            Mensaje SMS
            <FormControlLabel
              control={
                <Switch
                  checked={smsState}
                  disabled={!message.enabled}
                  onChange={data => {
                    message.sms.enabled = data.target.checked;
                    setSmsState(message.sms.enabled);
                  }}
                  inputProps={{ 'aria-label': 'Mensaje SMS Habilitado' }}
                />
              }
              label="Habilitado"
              style={{ marginLeft: 20 }}
            />
          </Typography>

          <Typography variant="body2">Excluya tildes y eñes</Typography>
          <TextareaAutosize
            name="sms"
            minRows={5}
            placeholder="Escriba el mensaje sin tildes ni eñes"
            defaultValue={message.sms.message}
            disabled={!message.enabled || !smsState}
            onChange={e => {
              message.sms = e.target.value;
            }}
            required
            style={{ width: '100%' }}
          />
        </Grid>

        <Grid item xs={12}>
          <Button
            id="submitButton"
            name="submitButton"
            type="button"
            onClick={() => {
              message.html.message = value;
              updateMessage(message);
            }}
            fullWidth
            variant="contained"
            className={classes.submit}
            color="primary"
          >
            GUARDAR
          </Button>
        </Grid>
      </Grid>
    </section>
  );
}
